import React from 'react'
import { Masonry as MuiMasonry } from '@mui/lab'
import { IImageDataProps } from '../../models/imageData'
import { Box, Theme, useTheme } from '@mui/material'

interface IMasonryProps {
  columns?: number
  spacing?: number
  itemData: IImageDataProps[]
}

const defaultSettings = {
  columns: 3,
  spacing: 2,
}

const Masonry: React.FC<IMasonryProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <Box component='section' sx={{ marginTop: theme.spacing(3), marginBottom: theme.spacing(3) }}>
      <MuiMasonry
        columns={props.columns ?? defaultSettings.columns}
        spacing={props.spacing ?? defaultSettings.spacing}
      >
        {props.itemData.map((item, idx) =>
          <img
            key={idx}
            srcSet={`${item.img}?w=162&auto=format&dpr=2 2x`}
            src={`${item.img}?w=162&auto=format`}
            alt={item.title}
            loading='lazy'
            style={{
              borderBottomLeftRadius: 4,
              borderBottomRightRadius: 4,
            }}
          />)}
      </MuiMasonry>
    </Box>
  )
}
export default Masonry
